import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '../constants';

export const industryService = {
  async list(params: { page?: number; limit?: number; search?: string; isActive?: boolean } = {}) {
    const query = new URLSearchParams();
    if (params.page) query.set('page', String(params.page));
    if (params.limit) query.set('limit', String(params.limit));
    if (params.search) query.set('search', params.search);
    if (typeof params.isActive === 'boolean') query.set('isActive', String(params.isActive));

    return apiClient.get(`${API_ENDPOINTS.INDUSTRIES.LIST}?${query.toString()}`, {
      authenticate: true,
    });
  },

  async details(id: string) {
    return apiClient.get(API_ENDPOINTS.INDUSTRIES.DETAILS(id), {
      authenticate: true,
    });
  },

  async create(payload: { name: string; description?: string; isActive?: boolean }) {
    return apiClient.post(API_ENDPOINTS.INDUSTRIES.CREATE, payload, {
      authenticate: true,
    });
  },

  async update(id: string, payload: { name?: string; description?: string; isActive?: boolean }) {
    return apiClient.patch(API_ENDPOINTS.INDUSTRIES.UPDATE(id), payload, {
      authenticate: true,
    });
  },

  async remove(id: string) {
    return apiClient.delete(API_ENDPOINTS.INDUSTRIES.DELETE(id), {
      authenticate: true,
    });
  },
};
